import { useContext, useEffect, useMemo, useState } from "react"
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { useCommanKit } from "./useCommanKit";

export const useLeaveTravel = ({ data, onNext }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [option, setOption] = useState([]);
    const [selectedOption, setSelectedOption] = useState("");
    const { getEmployeeDetails } = useCommanKit({ data });
    const [isChanged, setIsChanged] = useState(false);
    const [date,setDate] = useState({})

    useEffect(() => {
        const group = _.find(data?.attributeGroup, { attribute_group_key: "leave_travel_allowance" });
        if (group) {
            const options = _.filter(data?.attributeItems, { attribute_group_id: group.attribute_group_id })
                .map(item => ({
                    label: item.item_name,
                    value: item.attribute_item_id
                }));
            setSelectedOption(options[0]?.value)
            setOption(options);
        }
        getFinancialYearBlock()
    }, [data?.attributeGroup, data?.attributeItems]);

    const handleSubmit = async () => {
        if (!isChanged) {
            onNext();
            return;
        }
        if (!selectedOption) {
            showInfo("warn", "Please select option")
            return
        }
        const payload = {
            lta_option_item_id: parseInt(selectedOption)
        };
        try {
            const res = await services.getInvokeRemote("POST", Urls("UPSERTEMPLOYEELEAVETRAVELALLOWNCEDETAIL"), payload);
            if (!res?.body?.error_status) {
                showSuccess('Sucess', res.body.message)
                onNext()
            } else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error("Upsert error", error);
        }
    };

    useEffect(() => {
        data?.employee?.user_code && getEmployeeDetails("employee_lta_declaration", data?.employee?.user_code).then((res) => {
            setSelectedOption(res?.employee_lta_declaration?.[0]?.lta_option_item_id)
        }).catch((error) => {
            console.error(error)
        })
    }, [data?.employee]);


    function getFinancialYearBlock() {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();
        let startYear, endYear;
        if (month >= 3) {
            startYear = year;
            endYear = year + 1;
        } else {
            startYear = year - 1;
            endYear = year;
        }

        setDate({
            blockText: `1st April ${startYear} to 31st March ${endYear}`,
            endYearOnly: endYear
        });
    }

    return useMemo(() => ({
        option, handleSubmit, selectedOption, setSelectedOption, setIsChanged,date
    }), [option, handleSubmit, selectedOption, setSelectedOption, setIsChanged,date])
}